module.exports = __webpack_public_path__ + "img/about3.cd741a81.png";